import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AlignContainer, BaseSpinner } from 'wbs-components-lib';

import { Box, Typography } from '@mui/material';

import { useGetAllVipLevelsQuery } from '@services';

import { AppDispatch, getVipLevelsSelector, setVipLevels } from '@store';

import { VipLevelListProps } from './types';
import { VipLevelElement } from './VipLevelElement';

import styles from './VipLevelList.module.css';

const { vipLevelsList, vipLevelsListContainer } = styles;

export const VipLevelList: FC<VipLevelListProps> = ({
  handleVipLevelEditModalOpen,
  handleVipLevelDeleteModalOpen,
  handleVipLevelRewardEditModalOpen,
  handleVipLevelRewardDeleteModalOpen,
  handleVipLevelRewardCreateModalOpen,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const vipLevels = useSelector(getVipLevelsSelector);

  const [expandedVipLevelRewardsId, setExpandedVipLevelRewardsId] = useState<string>('');

  const { data: allVipLevels, isLoading: isVipLevelsLoading, isSuccess: isVipLevelsLoaded } = useGetAllVipLevelsQuery();

  useEffect(() => {
    if (isVipLevelsLoaded) {
      dispatch(setVipLevels(allVipLevels));
    }
  }, [isVipLevelsLoaded, allVipLevels]);

  const handleVipLevelRewardsExpand = (levelId: string) => {
    setExpandedVipLevelRewardsId(levelId);
  };

  return (
    <Box className={vipLevelsList}>
      {!isVipLevelsLoading ? (
        <>
          {vipLevels.length !== 0 ? (
            <Box className={vipLevelsListContainer}>
              {vipLevels.map((vipLevel) => (
                <VipLevelElement
                  key={vipLevel.id}
                  vipLevel={vipLevel}
                  handleVipLevelRewardsExpand={handleVipLevelRewardsExpand}
                  expandedVipLevelRewardsId={expandedVipLevelRewardsId}
                  handleVipLevelEditModalOpen={handleVipLevelEditModalOpen}
                  handleVipLevelDeleteModalOpen={handleVipLevelDeleteModalOpen}
                  handleVipLevelRewardEditModalOpen={handleVipLevelRewardEditModalOpen}
                  handleVipLevelRewardDeleteModalOpen={handleVipLevelRewardDeleteModalOpen}
                  handleVipLevelRewardCreateModalOpen={handleVipLevelRewardCreateModalOpen}
                />
              ))}
            </Box>
          ) : (
            <Typography align="center" margin="50px">
              There are no levels at the moment. Please add a first one! 🤗
            </Typography>
          )}
        </>
      ) : (
        <AlignContainer>
          <BaseSpinner />
        </AlignContainer>
      )}
    </Box>
  );
};
